import { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { PageContentStateContext } from '@src/contexts/wysiwyg/page_content';
import { updateTextContentItemBackgroundColor, saveSnapshot } from '../../actions/wysiwyg/editor';
import { isTextBox } from '@src/utils/wysiwyg_editor/data';

type Color = string | null | undefined;

function useSetTextBackgroundColor(): (color: Color) => void {
  const dispatch = useDispatch();
  const { selectedPageContentItem } = useContext(PageContentStateContext);

  return (color: Color) => {
    if (!isTextBox(selectedPageContentItem)) return;

    dispatch(saveSnapshot());
    dispatch(updateTextContentItemBackgroundColor(selectedPageContentItem.id, color));
  };
}

export default useSetTextBackgroundColor;
